<template>
  <div class="survey-template">

    <table class="floodHazard">
      <thead>
        <tr class="blue accent-4 white-text">
          <th colspan="2">Flood Hazard</th>
        </tr>
        <tr>
          <th>Question</th>
          <th>Answer</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(items, key) in dataSurvey.survey" :key="key" v-show="key in floodHazardSchema">
          <td v-if="key in floodHazardSchema">
            {{ floodHazardSchema[key] ? floodHazardSchema[key].label : "" }}
          </td>
          <td v-if="Array.isArray(items)">
            <p v-for="(text, index) in items" :key="index">
              {{
                floodHazardSchema[key].options
                ? floodHazardSchema[key].options[text]
                : ""
              }}
            </p>
          </td>
          <td v-else-if="items === 'yes'">
            <span class="material-icons-outlined green-text text-lighten-2 ">
              task_alt
            </span>
          </td>
          <td v-else-if="items === 'no'">
            <span class="material-icons-outlined red-text text-lighten-2 ">
              cancel
            </span>
          </td>
          <td v-else-if="items === 'minor'" class="green-text text-lighten-2">
            {{ dataSurvey.survey[key] }}
          </td>
          <td v-else-if="items === 'moderate'" class="yellow-text text-lighten-2">
            {{ dataSurvey.survey[key] }}
          </td>
          <td v-else-if="items === 'major'" class="orange-text text-lighten-1">
            {{ dataSurvey.survey[key] }}
          </td>
          <td v-else-if="items === 'extreme'" class="red-text text-lighten-2">
            {{ dataSurvey.survey[key] }}
          </td>
          <td v-else>{{ items }}</td>
        </tr>
      </tbody>
    </table>

    <summary-assessment summary-label="Flood Hazard" :data-value="dataSurvey" />
  </div>
</template>

<script>
import floodHazardSchema from "@/JsonSchemas/floodHazard.json";
import summaryAssessment from "@/components/admin/summaryAssessment.component";
export default {
  name: "FloodHazardReview",
  components: {
    summaryAssessment,
  },
  props: {
    dataSurvey: {
      type: Object,
    },
  },
  data() {
    return {
      floodHazardSchema,
      ready: false,
    };
  },
  mounted() {
    this.dataSurvey && (this.ready = true);
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.survey-template {
  table {
    thead {
      background: rgba(0, 0, 0, 0.08);
      padding: 12px;
    }
  }

  td,
  th {
    border: 1px solid lightgray !important;
    padding: 12px;

    p {
      margin: 6px 0px;
    }
  }

}
</style>
